import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCounterStrikeComponent } from './simple-icons-counter-strike.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCounterStrikeComponent ],
    exports:      [ SimpleIconsCounterStrikeComponent ],
    bootstrap:    []
})
export class SimpleIconsCounterStrikeModule {}
